import EmployeeModel from "./EmployeeModel";
import ItemModel from "./ItemModel";

export default class OrderItemModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
			this.date = data.date ?? new Date(1970, 0, 1);
			this.count = data.count ?? 0;
            this.discountPercent = data.discountPercent ?? 0;
            this.overridenPrice = data.overridenPrice;

			if (data.item) {
				this.item = new ItemModel(data.item);
			}

			if (data.manager) {
				this.manager = new EmployeeModel(data.manager);
			}

			this.purchasePrice = data.purchasePrice ?? 0;
			this.marginPercent = data.marginPercent ?? 0;
			this.totalPrice = data.totalPrice ?? 0;
		}
	}

	id = 0;
	date = new Date(1970, 0, 1);
	count = 0;
	discountPercent = 0;
	overridenPrice: number | null = null;
	item: ItemModel | null = null;
	manager: EmployeeModel | null = null;
	purchasePrice = 0;
	marginPercent = 0;
	totalPrice = 0;
}